import React from "react";

const Login = () => {
  const SAML_LOGIN_URL = "/auth/saml";

  const handleLogin = () => {
    // SPA遷移ではなく、ブラウザごとRailsの認証エンドポイントへ移動
    window.location.href = SAML_LOGIN_URL;
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: "100vh", backgroundColor: "#f0f2f5" }}
    >
      <div
        className="card shadow-sm border-0 p-5 text-center"
        style={{ width: "100%", maxWidth: "400px" }}
      >
        {/* ロゴエリア */}
        <div className="mb-4 text-primary">
          <svg
            width="64"
            height="64"
            fill="currentColor"
            className="bi bi-calendar-check"
            viewBox="0 0 16 16"
          >
            <path d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z" />
            <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
          </svg>
        </div>

        <h1 className="h3 fw-bold mb-3">業務報告システム</h1>
        <p className="text-muted mb-4">ログインして作業を開始します</p>

        <div className="d-grid gap-2">
          {/* SSOログインボタン */}
          <button
            className="btn btn-primary btn-lg fw-bold"
            onClick={handleLogin}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            {/* Windowsアイコン風デザイン */}
            <span
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "2px",
                width: "16px",
                height: "16px",
              }}
            >
              <span style={{ background: "white" }}></span>
              <span style={{ background: "white" }}></span>
              <span style={{ background: "white" }}></span>
              <span style={{ background: "white" }}></span>
            </span>
            SSOログイン
          </button>
        </div>

        <div className="mt-4 border-top pt-3">
          <small className="text-muted">Managed by Denno Kotsu Corp.</small>
        </div>
      </div>
    </div>
  );
};

export default Login;
